module.exports = __webpack_public_path__ + "img/어이젊은친구.7c94fdc5.png";